import "./Footer.css";
import { FaHome } from "react-icons/fa";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content">
                <a href="/hod" className="footer-home-icon">
                    <FaHome size={20} />
                </a>
                <span className="footer-rights">
                    {currentYear} &copy; Developed by Baashyaam Software Developement Team. All rights reserved.
                </span>
            </div>
        </footer>
    );
}
